import React from "react";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import ViewLogin from "@views/ViewLogin";
import { ModalComponents } from "@hlibs/index";
import { ThemeProvider } from "@mui/material/styles";
import ViewDashboard from "./views/ViewDashboard";
import CompDashboard from "@components/CompDashboard";
import CompAdCurrent from "@components/CompAd/CompAdCurrent";
import CompAdAdd from "@components/CompAd/CompAdAdd";
import CompAdvertiserAdd from "@components/CompAdvertiser/CompAdvertiserAdd";
import CompAdvertiserInfo from "@components/CompAdvertiser/CompAdvertiserInfo";
import CompProfile from "@components/CompProfile";
import { MenuProvider } from "@assets/contexts/MenuContext";
import "./App.css";
import { theme } from "@app/theme";
import LoadingBackdrop from "@assets/loadingBackdrop";

function App() {
  return (
    <>
      <ThemeProvider theme={theme}>
        <MenuProvider>
          <BrowserRouter>
            <Routes>
              <Route path="/login" element={<ViewLogin />} />
              <Route element={<ViewDashboard />}>
                <Route path="/" element={<CompDashboard />} />
                <Route path="/ad">
                  <Route path="" element={<CompAdCurrent />}></Route>
                  <Route path="add" element={<CompAdAdd />}></Route>
                </Route>
                <Route path="/advertiser">
                  <Route path="" element={<CompAdvertiserAdd />}></Route>
                  <Route path="info" element={<CompAdvertiserInfo />}></Route>
                </Route>
                <Route path="/profile">
                  <Route path="" element={<CompProfile />}></Route>
                </Route>
              </Route>
            </Routes>
          </BrowserRouter>
          <ModalComponents backgroundColor={"#00000090"} />
          <LoadingBackdrop />
        </MenuProvider>
      </ThemeProvider>
    </>
  );
}

export default App;
